/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminDeletedByDto { 
    id: string;
    /**
     * Display name of the admin who performed the delete
     */
    name: string;
    /**
     * Soft-delete timestamp (ISO 8601)
     */
    deletedAt: string;
}

